import { ProductFilterInput } from '@app-domains/meilisearch/types/product-search.types'

const NUMERIC_FILTER_PATTERN = /^([\w.]+)\s*(>=|<=|>|<|=)\s*(-?\d+(?:\.\d+)?)$/

export function mapNumericFilters(
    numericFilters: string | string[] | undefined,
): ProductFilterInput[] {
    if (numericFilters == null) {
        return []
    }

    const entries = Array.isArray(numericFilters) ? numericFilters : [numericFilters]
    const byAttribute = new Map<string, { min?: number; max?: number; eq?: number }>()

    for (const entry of entries) {
        const match = entry.match(NUMERIC_FILTER_PATTERN)

        if (! match) {
            continue
        }

        const [, attribute, operator, rawValue] = match
        const value = Number(rawValue)
        const bucket = byAttribute.get(attribute) ?? {}

        switch (operator) {
            case '>':
            case '>=':
                bucket.min = bucket.min === undefined ? value : Math.max(bucket.min, value)
                break
            case '<':
            case '<=':
                bucket.max = bucket.max === undefined ? value : Math.min(bucket.max, value)
                break
            case '=':
                bucket.eq = value
                break
        }

        byAttribute.set(attribute, bucket)
    }

    const filters: ProductFilterInput[] = []

    byAttribute.forEach((bucket, attribute) => {
        if (bucket.eq !== undefined) {
            filters.push({
                attribute,
                operator: 'EQ',
                values: [String(bucket.eq)],
            })

            return
        }

        if (bucket.min !== undefined && bucket.max !== undefined) {
            filters.push({
                attribute,
                operator: 'RANGE',
                values: [String(bucket.min), String(bucket.max)],
            })

            return
        }

        if (bucket.min !== undefined) {
            filters.push({
                attribute,
                operator: 'GTE',
                values: [String(bucket.min)],
            })
        }

        if (bucket.max !== undefined) {
            filters.push({
                attribute,
                operator: 'LTE',
                values: [String(bucket.max)],
            })
        }
    })

    return filters
}
